import Phaser from 'phaser';
import { PreloadScene } from '@game/scenes/PreloadScene';
import { MenuScene } from '@game/scenes/MenuScene';
import { CharacterCreatorScene } from '@game/scenes/CharacterCreatorScene';
import { IntroScene } from '@game/scenes/IntroScene';
import { WorldMapScene } from '@game/scenes/WorldMapScene';
import { HudScene } from '@game/scenes/HudScene';
import { MapHudScene } from '@game/scenes/MapHudScene';
import { VoyageEventScene } from '@game/scenes/VoyageEventScene';
import { SiteScene } from '@game/scenes/SiteScene';
import { EvidenceScene } from '@game/scenes/EvidenceScene';
import { FinaleScene } from '@game/scenes/FinaleScene';
import { ImprintScene } from '@game/scenes/ImprintScene';
import { audio } from '@game/audio/engine';

const game = new Phaser.Game({
  type: Phaser.AUTO,
  parent: 'game',
  backgroundColor: '#05080d',
  scale: {
    mode: Phaser.Scale.RESIZE,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  // Die Karte ist eine grosse, ruhige Flaeche — sanftes Filtern sieht dort
  // deutlich besser aus als harte Pixelkanten.
  render: { antialias: true, roundPixels: false },
  scene: [
    PreloadScene,
    MenuScene,
    CharacterCreatorScene,
    IntroScene,
    WorldMapScene,
    HudScene,
    MapHudScene,
    VoyageEventScene,
    SiteScene,
    EvidenceScene,
    FinaleScene,
    ImprintScene,
  ],
});

// Im Entwicklungsmodus greifbar machen: erlaubt es, den Spielzustand aus der
// Browserkonsole heraus zu inspizieren und Szenen gezielt anzusteuern.
if (import.meta.env.DEV) {
  const dev = globalThis as unknown as { game: Phaser.Game; audio: typeof audio };
  dev.game = game;
  dev.audio = audio;
}
